'use strict';
import $ from 'jquery';

export default class Marketo {
    static init() {
        $('[data-marketo-form]').each((index, el) => {
            new Marketo($(el));
        });
    }
    // 

    constructor($el) {
        this.el = $el;
        this.form_id = this.el.data('marketo-form');
        console.log("form element: ", this.form_id);
        this.loadForm();
    }

    loadForm() {
        MktoForms2.loadForm("//go.open-systems.com", "514-ZBL-151", this.form_id);
    }
}